var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.21 5.133a5.512 5.512 0 01-.472-.275 6.633 6.633 0 01-1.213-1.031c-.905-1.036-1.243-2.086-1.368-2.822h.006C15.059.395 15.1 0 15.108 0h-4.122v15.938c0 .214 0 .426-.009.635l-.003.078c0 .011 0 .023-.003.035v.01a3.5 3.5 0 01-1.76 2.777c-.52.296-1.108.451-1.706.45-1.921 0-3.477-1.566-3.477-3.5s1.556-3.5 3.477-3.5c.363 0 .724.057 1.07.17l.005-4.197a7.657 7.657 0 00-5.9 1.726 8.09 8.09 0 00-1.765 2.176c-.174.3-.83 1.506-.91 3.462-.05 1.11.284 2.261.443 2.737v.01c.1.28.487 1.235 1.119 2.04a8.37 8.37 0 001.785 1.685v-.01l.01.01c1.995 1.356 4.208 1.267 4.208 1.267.383-.016 1.666 0 3.123-.69 1.616-.766 2.536-1.907 2.536-1.907a7.922 7.922 0 001.382-2.296c.373-.98.497-2.157.497-2.627V8.024c.05.03.716.47.716.47s.96.615 2.457 1.016c1.074.285 2.52.345 2.52.345V5.763c-.506.055-1.536-.105-2.59-.63z"
  })));
}
export default SvgTiktok;